import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select'
import DatePicker from 'vue2-datepicker'
import Printd from 'printd'
import user_tracker from '../../../../usertracker'
import index from '../../../../utils/index';

export default {
  name: 'scheduled-list',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    DatePicker
  },
  props: [],
  data() {
    return {
      pageCountrule: 0,
      pageCount: 0,
      pageNo: 0,
      isLoading: false,
      schedulesList: [],
      username: '',
      uasertype: '',
      hubid: '',
      //for filter schedule list
      tripsheetnoflt: '',
      status: 'InProcess',
      vendornameitem: {
        value: '',
        text: ''
      },
      vendorname: '',
      vendornameLoading: '',
      fromdate: '',
      todate: '',
      connectiontype: '',
      VehicleCapacityData: {},

      //for RegularPrint
      showPrintModal: false,
      isLoading: false,
      showTable: true,
      touchpointlist: [],
      touchpointitem: {
        value: '',
        text: ''
      },
      touchpointname: '',
      lineHaulObjData: {
        coloadername: "",
        routemode: "",
        vehiclename: "",
        vehicleno: "",
        awbno: "",
        pcs: "",
        totalphysicalweight: "",
        totalvolumetricweight: "",
        boggieno: "",
        breakno: "",
        traintype: "",
        rrno: "",
        rrno1: "",
        rrno2: "",
        departuredate: "",
        departuretime: "",
        scheduledate: "",
        arrivaldate: "",
        arrivaltime: "",
        printDate: "", //
        printBy: "", //
        connectionname: "",
        departuredate: "",
        departuretime: "",
        noofbags: "",
        fullConnectionName: '',
      },
      lineHaulShipmentObjData: [{
        bagtype: "",
        bagno: "",
        parentBags: "",
        totalShipments: "",
        destinationhubid: "",
        physicalweight: "]",
        volumetricweight: ""
      }],
      printDate: '',
      printBy: '',
      isDisplay: true,
      tripid: '',
      tripdata: {},
      tripdatafound: false,
      currenthubid: '',
      currenthub: '',
      connectionschedulemasterid: '',
      shipmentdata: [],
      shipmentdataLength: 0,
      modaldata: '',
      vendortype: '',
      isValidPrint : false,
      printConfig : false,
      printTripNo: '',
      //for paper work Model
      paperData: '',
      paperWorkModel: false,
      opened: [],
      ParentPaperData: [],
      ChildPaperData: [],
      isLoadingPrintSheet: false,

      //for Loading Trip Sheet
      showSheetModal: false,
      SheetPrintdata: '',
      isLoadingSheetModal: false,
      SheetPrintDataList: [],
      len: [],
      IsSheet: false,
      selectedbags: [],

      //for Gate pass
      viewtripmodel: false,
      GatePassDetails: [],
      DestLoadCount: [],
      DestLoadCountUpdated: [],
      ebnDetailsB2B: [],
      ebnDetailsB2C: [],
      PrintDate: '',
      PrintBy: '',
      CSMID: '',
      invoiceno: '',

      // for Token
      token: '',
      invalidTokenModal: false,
      invalidtokenmsg: ''

    }
  },
  //for RegularPrint
  model: {
    totalVolWt: 0,
    totalPhyWt: 0,
    totalLineHaulBags: 0,
    totalBags: 0,
    totalShipments: 0
  },
  computed: {
    //for RegularPrint
    TotalVolWt: function() {
      return this.lineHaulShipmentObjData.reduce(function(totalVolWt, item) {
        return totalVolWt + parseFloat(item.volumetricweight);
      }, 0);
    },
    TotalPhyWt: function() {
      return this.lineHaulShipmentObjData.reduce(function(totalPhyWt, item) {
        return totalPhyWt + parseFloat(item.volumetricweight);
      }, 0);
    },
    TotalLineHaulBags: function() {
      return this.lineHaulShipmentObjData.length
    },
    TotalBags: function() {
      return 0;
      // return this.lineHaulShipmentObjData.reduce(function(totalBags, item) {
      // 	return totalBags + parseFloat(item.volumetricweight);
      // }, 0);
    },
    TotalShipments: function() {
      return this.lineHaulShipmentObjData.reduce(function(totalShipments, item) {
        return totalShipments + parseFloat(item.totalshipments);
      }, 0);
    }

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
      // var with2Decimals = val.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      // return  with2Decimals
    },

    //for RegularPrint
    momentDate: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    },
    momentTime: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('HH:mm:ss');
    },
    jsUcfirst: function(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getHubDetails(arr) {
      if (arr.length < 1) {
        return '';
      }

      var input = {
        hubids: [arr[(arr.length) - 1].HubID]
      }
      return axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + "expose/hubservicecenter/hubarray/get",
          'data': input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          return result.data.ResponseData[0].HubName
        }, error => {
          console.error(error)
        })
    },
  },
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.uasertype = userdetail[0].utype;
    this.username = userdetail[0].FirstName;
    this.hubid = userdetail[0].HubId;
    this.useremail = userdetail[0].email
    user_tracker.checkUserIP(userdetail[0], "searchNetworkTrip", this.$route.path);
    this.fromdate = new Date()
    this.todate = new Date()
    this.getHubDetails();
    //for RegularPrint
    this.warehouseid = userdetail[0].warehouseid;
    this.createdBy = userdetail[0].email;
    this.printDate = moment().format('DD-MM-YYYY');
    this.printBy = userdetail[0].email;
  },
  methods: {
    getHubDetails() {
      this.input = {
        hubids: this.hubid
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubdata = result.data.ResponseData[0];
          } else {
            this.hubdata = '';
          }
        }, error => {
          console.error(error)
        })
    },
    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    editTrip(data) {
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getVehicleCapacityforSchedule?ConnectionScheduleMasterId=' + data.connectionschedulemasterid + '&TripID=' + data.tripid + '&CurrentHubId=' + data.currenthubid,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            var VehicleCapacityData = result.data.ResponseData
            let routeData = this.$router.push({
              path: "GenerateTripSheet",
              query: {
                scheduleData: data,
                VehicleCapacityData: VehicleCapacityData
              }
            })
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })

    },
    //for filter schedule list
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD HH:MM:SS');
    },
    searchVehicleList() {
      this.isLoading = true;
      this.input = ({
        "hubId": this.hubid[0]
      })
      if (this.fromdate != "" && this.fromdate != null) {
        this.input.fromDate = moment(this.fromdate).format('YYYY-MM-DD');
      }
      if (this.todate != "" && this.todate != null) {
        this.input.toDate = moment(this.todate).add(1, 'days').format('YYYY-MM-DD');
      }
      if (this.vendornameitem.value != "" && this.vendornameitem.value != null) {
        this.input.vendorId = this.vendornameitem.value;
      }
      if (this.tripsheetnoflt != "" && this.tripsheetnoflt != null) {
        this.input.tripSheetNo = this.tripsheetnoflt;
      }
      if (this.status != "" && this.status != null) {
        this.input.status = this.status;
      }
      if (this.connectiontype != "" && this.connectiontype != null) {
        this.input.connectionType = parseInt(this.connectiontype);
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'searchScheduleTripsList',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.isLoading = false;
            this.invalidTokenModal = false
            this.schedulesList = result.data.ResponseData;
            this.$alertify.success(result.data.ReturnMessage)

            // let totalRows = this.schedulesList
            // if (totalRows < 15) {
            //   this.pageCountrule = 1
            // } else {
            //   this.pageCountrule = Math.ceil(totalRows / 15);
            // }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.isLoading = false;
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.isLoading = false
            this.invalidTokenModal = false
            this.schedulesList = [];
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoading = false
          console.error(error)
        })
    },
    selectedVendor(vendornameitem) {
      this.vendornameitem = vendornameitem
      this.vendorname = vendornameitem.text
    },
    resetflt() {
      this.schedulesList = []
      this.vendornameitem = {
        value: '',
        text: ''
      }
      this.vendorname = ''
      this.vendornameLoading = ''
      this.fromdate = ''
      this.todate = ''
      this.tripsheetnoflt = ''
      this.status = ''
      this.connectiontype = ''
      this.printTripNo = ''
      this.$validator.reset()
    },
    onSubmitflt: function() {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        } else {
          this.searchVehicleList();
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    printManifestData(tripid, currenthubid, connectionschedulemasterid, connectionid) {
      localStorage.setItem('pageName','Network Connection Schedule');
      let path = this.$router.resolve("/TripSheetPrint/" + tripid.trim() + "/" + currenthubid + "/" + connectionschedulemasterid + "/" + connectionid)
      window.open(path.href, '_blank');
    },
    //for RegularPrint
    openRegularPrintModal(data) {
      this.showPrintModal = true
      this.modaldata = data
      this.printTripNo = this.modaldata.tripno;
      this.getTripDetails();

    },
    closeRegularPrintModal() {
      this.showPrintModal = false
      this.touchpointlist = []
      this.touchpointitem = {
        value: '',
        text: ''
      }
      this.touchpointname = ''
    },
    // selectedTouchPoint(touchpointitem) {
    //   this.touchpointitem = touchpointitem
    //   this.touchpointname = touchpointitem.text
    //   if (this.touchpointname != '') {
    //     var stoppointarr = []
    //     stoppointarr.push(this.touchpointitem.value)
    //     this.getshipmentdata(stoppointarr, this.currenthubid, this.connectionschedulemasterid);
    //   }
    // },
    getTripDetails() {
      this.tripdata = {};
      this.shipmentdata = {};
      this.isLoadingPrintSheet = true;
      this.tripdatafound = false;
      this.isValidPrint = false;
      this.printConfig = false;
      this.input = {
        "currentHubId" : Number(this.hubid[0]),
        "VendorVehicleTripID": parseInt(this.modaldata.tripno)
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'GetNetworkTripDetails',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoadingPrintSheet = false
          if (result.data.ResultCode == 100) {
            this.isValidPrint = result.data.isValidPrintRestrictions;
            this.printConfig = index.configRolesCheck(result.data.config.pr_web_roles);
            var response = result.data.ResponseData[0];
            var tripdata = response;
            this.tripdata = response;
            if (this.tripdata.TripType == 'MarketHired') {
              this.vendortype = 'Market'
            } else if (this.tripdata.TripType == 'VendorBased' || this.tripdata.TripType == 'NetworkBased' || this.tripdata.TripType == 'Network') {
              this.vendortype = 'Attached'
            } else {
              this.vendortype = ''
            }
            var stoppointarr = [];
            if (tripdata.Connectiondetails.length > 0) {
              var stoppoints = tripdata.Connectiondetails[0].Stoppoints
              for (var i = 0; i < stoppoints.length; i++) {
                stoppointarr.push(stoppoints[i].StopPointHubId);
                // this.touchpointlist.push({
                //   value: stoppoints[i].StopPointHubId,
                //   text: stoppoints[i].StopPointName,
                // });
              }
            }
            this.getshipmentdata(stoppointarr, this.currenthubid, this.connectionschedulemasterid);

            var arr = tripdata.ShipmentDetails
            if (arr.length > 0) {
              var input = {
                hubids: [arr[(arr.length) - 1].HubID]
              }
              return axios({
                  method: 'POST',
                  'url': apiUrl.api_url_hubops + "expose/hubservicecenter/hubarray/get",
                  'data': input,
                  headers: {
                    'authorization': 'authkey xB84JJ89Hd25',
                  }
                })
                .then(result => {
                  this.currenthub = result.data.ResponseData[0].HubName
                  this.tripdata = tripdata
                }, error => {
                  console.error(error)
                })

            }

          } else {
            this.$alertify.error("No record found")
          }
        }, error => {
          this.isDisplay = false
          console.error(error)
        })

    },
    getshipmentdata(stoppoints, currenthubid, connectionschedulemasterid) {
      this.shipmentdataLength = 0
      this.shipmentdata = []
      this.fullConnectionName = ''
      this.isLoadingPrintSheet = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getShipmentsFromTouchPoints?ConnectionScheduleMasterID=' + this.modaldata.connectionschedulemasterid + '&CurrentHubId=' + this.modaldata.currenthubid + '&TouchPointHubId=' + stoppoints.join(','),
          // 'url': "http://huboperation-apistage.xbees.in/api/getShipmentsFromTouchPoints?ConnectionScheduleMasterID=" + this.modaldata.connectionschedulemasterid + "&CurrentHubId=" + this.modaldata.currenthubid + "&TouchPointHubId=" + stoppoints.join(','),
          headers: {
            'Authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          var shdata = [];
          this.isLoadingPrintSheet = false;
          if (result.data.ResultCode == 100) {
            this.isLoading = false;
            this.tripdatafound = true;
            this.shipmentdata = result.data.ResponseData;
            this.fullConnectionName = result.data.fullConnectionName;
            var baglength = Object.values(this.shipmentdata);
            Array.prototype.getLength = function() {
              function getMultiLength(array) {
                var sum = 0;
                for (var count = 0; count < array.length; count++) {
                  if (Array.isArray(array[count])) {
                    sum += getMultiLength(array[count]);
                  } else {
                    sum++;
                  }
                }
                return sum;
              }
              return getMultiLength(this.valueOf());
            };
            this.shipmentdataLength = baglength.getLength();
          } else {
            this.isLoading = false;
            this.shipmentdata = [];
            this.fullConnectionName = '';
            this.tripdatafound = false;
            this.$alertify.error("No record found")
          }
          this.isLoading = false
        }, error => {
          this.isDisplay = false
          this.isLoading = false
          this.isLoadingPrintSheet = false;
          console.error(error)
        })
    },
    gettotalshipments(d) {
      var totalShipments = 0;
      for (var i = 0; i < d.length; i++) {
        totalShipments = totalShipments + parseInt(d[i].shipmentcount)
      }
      return totalShipments;
    },
    gettotalphywt(d) {
      var totalphywt = 0;
      for (var i = 0; i < d.length; i++) {
        totalphywt = totalphywt + parseFloat(d[i].physicalweight)
      }
      return totalphywt;
    },
    gettotalcharwt(d) {
      var totalcharwt = 0;
      for (var i = 0; i < d.length; i++) {
        totalcharwt = totalcharwt + parseFloat(d[i].chargeableweight)
      }
      return totalcharwt;
    },
    gettotalvolwt(d) {
      var totalvorwt = 0;
      for (var i = 0; i < d.length; i++) {
        totalvorwt = totalvorwt + parseFloat(d[i].volumetricweight)
      }
      return totalvorwt;
    },
    printLineHaul(type) {
      const d = new Printd();
      var buffer = '';

      this.input = {
        "currentHubId" : Number(this.hubid[0]),
        "tripId" : Number(String(this.printTripNo).trim()),
        "createdBy" : this.useremail,
        "reportName" : type,
        "pageName" : "Network Connection Schedule"
      }
      axios({
        method: 'post',
        url: apiUrl.api_url_hubops + 'printGatePass',
        data: this.input,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'authkey xB84JJ89Hd25',
        },
			})
      .then((result) => {
        if(result.data.ResultCode == 100) {
          this.alertify.success(result.data.ReturnMessage);
        } else {
          this.alertify.error(result.data.ReturnMessage);
				}
      })
      .catch((error) => console.log(error));

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          `
      d.print(document.getElementById('tripsheetContent'), cssText);
    },
    toFixedVal(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
    },
    //For Paper work Model
    openPaperWorkModel(data) {
      this.paperWorkModel = true
      this.paperData = data
      this.getParentPaperData();
    },
    closePaperWorkModel() {
      this.paperWorkModel = false
    },
    getParentPaperData() {
      this.opened = [];
      this.ParentPaperData = []
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getPaperBagsByConnectionScheduleMasterId?connectionScheduleMasterId=' + this.paperData.connectionschedulemasterid + '&hubId=' + this.paperData.currenthubid,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.ParentPaperData = result.data.ResponseData;
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.ParentPaperData = []
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    getChildPaperData(data, ind) {
      const index = this.opened.indexOf(ind);
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened = [];
        this.ChildPaperData = []
        this.opened.push(ind)
        axios({
            method: 'GET',
            url: apiUrl.api_url_hubops + 'getPaperBagDetailsByPaperBagNo?paperBagNo=' + data.paperbagno,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.ChildPaperData = result.data.ResponseData;
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.ChildPaperData = []
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      }
    },
    closeChildPaperDataList() {
      this.opened = [];
    },
    //for Loading Sheet Print
    loadingSheetPrint(data) {
      this.showSheetModal = true
      this.SheetPrintdata = data
      this.getSheetePrintdata()
    },
    closeSheetModal() {
      this.showSheetModal = false
    },
    getSheetePrintdata() {
      this.SheetPrintDataList = []
      this.isLoadingSheetModal = true
      this.isValidPrint = false;
      this.printConfig = false;
      this.printTripNo = '';
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getPaperBagsWithAWBDetailsByConnectionScheduleMasterId?connectionScheduleMasterId=' + this.SheetPrintdata.connectionschedulemasterid + '&hubId=' + this.SheetPrintdata.currenthubid,
          headers: {
            'Authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoadingSheetModal = false
          if (result.data.ResultCode == 100) {
            this.SheetPrintDataList = result.data.ResponseData;
             this.printTripNo = result.data.tripId;
            this.isValidPrint = result.data.isValidPrintRestrictions;
            this.printConfig =  index.configRolesCheck(result.data.config.pr_web_roles);
            this.len = Object.keys(this.SheetPrintDataList);
            this.IsSheet = true
          } else {
            this.SheetPrintDataList = []
            this.IsSheet = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.SheetPrintDataList = []
          this.IsSheet = false
          this.isLoadingSheetModal = false
          console.error(error)
        })
    },
    getBag(string) {
      let reg = /.{1,6}/
      return string.replace(reg, (m) => "*".repeat(m.length))
    },
    gettotalMPSCount(row) {
      var totalMPSCount = 0;
      for (var i = 0; i < row.length; i++) {
        totalMPSCount = totalMPSCount + parseFloat(row[i].mpscount)
      }
      return totalMPSCount;
    },
    gettotalWeight(row) {
      var totalWeight = 0;
      for (var i = 0; i < row.length; i++) {
        totalWeight = totalWeight + parseFloat(row[i].parentawbweight)
      }
      return totalWeight;
    },

    formatWeight(value) {
      if (!value) return '0';
      const num = parseFloat(value);
      return Number.isInteger(num) ? `${num}` : `${parseFloat(num.toFixed(2))}`;
    },

    //for gate Pass
    showGatePass(data) {
      this.viewtripmodel = true;
      this.CSMID = data.connectionschedulemasterid;
      this.invoiceno = data.invoiceno;
      this.PrintBy = this.createdBy
      this.PrintDate = new Date();
      this.printTripNo = '';
      this.DestLoadCount = [];
      this.DestLoadCountUpdated = [];
      this.ebnDetailsB2B = [];
      this.ebnDetailsB2C = [];
      this.input = ({})
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'generateGatePass?ConnectionScheduleMasterID=' + this.CSMID,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.GatePassDetails = index.getHubNameByHubId([result.data.ResultData[0].CurrentHub], result.data.ResultData, 'CurrentHub');;
            this.DestLoadCount = result.data.Count;
            this.transitLocationHubIds = [...new Set(this.DestLoadCount.map(a => a.transit_location))];
            if(this.transitLocationHubIds.length > 0) {
              this.DestLoadCountUpdated = index.getHubNameByHubId(this.transitLocationHubIds, this.DestLoadCount, 'transit_location');
            }
            this.ebnDetailsB2B = result.data.ebn.B2Bebn;
            this.ebnDetailsB2C = result.data.ebn.B2Cebn;
            this.printTripNo = result.data.ResultData[0].thcno
            this.viewtripmodel = true;
          }else{
            this.viewtripmodel = false;
            this.$alertify.error(result.data.ReturnMessage);
            
          }
        }, error => {
          console.error(error)
        })
    },
    hideviewtripmodel() {
      this.CSMID ='';
      this.viewtripmodel = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    printGatePass(type) {
      const d = new Printd();
      var buffer = '';

       this.input = {
        "currentHubId" : Number(this.hubid[0]),
        "tripId" : Number(String(this.printTripNo).trim()),
        "createdBy" : this.useremail,
        "reportName" : type,
        "pageName" : "Network Connection Schedule"
      }
      axios({
        method: 'post',
        url: apiUrl.api_url_hubops + 'printGatePass',
        data: this.input,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'authkey xB84JJ89Hd25',
        },
			})
      .then((result) => {
        if(result.data.ResultCode == 100) {
          this.alertify.success(result.data.ReturnMessage);
        } else {
          this.alertify.error(result.data.ReturnMessage);
				}
      })
      .catch((error) => console.log(error));

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          `
      if (type == "LoadingPrintSheet") {
        d.print(document.getElementById('tripsheetContent'), cssText);
      } else {
        d.print(document.getElementById('GatePass'), cssText);
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/NetworkManagement/searchNetworkTrip/searchNetworkTrip.js